namespace Ir.Components.Workbook.Widgets.ChartWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: ChartWidget;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        let chartWidget: ChartWidget = params.widget;
        chartWidget.set$ReportContent(componentInfo.element);
        chartWidget.setup();
    }
}